// Logos oficiales (inline SVG) para servicios de estado externos en /admin/monitor-externo.
// Inline para que no dependan de carga de imágenes ni de CDN.

export function SupabaseLogo({ size = 24, className = '' }) {
  return (
    <svg
      width={size} height={size}
      viewBox="0 0 113 113"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Supabase"
    >
      <defs>
        <linearGradient id="sb-g1" x1="53.974" y1="54.974" x2="94.163" y2="71.829" gradientUnits="userSpaceOnUse">
          <stop stopColor="#249361" />
          <stop offset="1" stopColor="#3ECF8E" />
        </linearGradient>
        <linearGradient id="sb-g2" x1="36.156" y1="30.578" x2="54.484" y2="65.081" gradientUnits="userSpaceOnUse">
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path
        d="M63.71 110.284c-2.85 3.59-8.637 1.622-8.7-2.962L54.085 40.7h45.225c8.19 0 12.758 9.46 7.661 15.864L63.71 110.284z"
        fill="url(#sb-g1)"
      />
      <path
        d="M63.71 110.284c-2.85 3.59-8.637 1.622-8.7-2.962L54.085 40.7h45.225c8.19 0 12.758 9.46 7.661 15.864L63.71 110.284z"
        fillOpacity="0.2"
        fill="url(#sb-g2)"
      />
      <path
        d="M45.317 2.071c2.85-3.59 8.637-1.622 8.7 2.962l.925 66.622H9.99c-8.19 0-12.759-9.46-7.661-15.864L45.317 2.071z"
        fill="#3ECF8E"
      />
    </svg>
  )
}

export function CloudflareLogo({ size = 24, className = '' }) {
  return (
    <svg
      width={size} height={size * (78 / 196)}
      viewBox="0 0 196.4 78.3"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Cloudflare"
    >
      <path
        fill="#FFFFFF"
        d="M154.6 57.5l1.1-3.8c1.3-4.5.8-8.7-1.4-11.8-2-2.8-5.5-4.5-9.6-4.6L66 36.3c-.5 0-.9-.3-1.2-.7-.2-.4-.3-.9-.1-1.4.3-.8 1.1-1.4 2-1.4l79.9-1c9.5-.4 19.7-8.1 23.3-17.4l4.6-11.8c.2-.5.3-1 .1-1.5C170 .8 164.5 0 158.6 0c-32.4 0-58.6 26.2-58.6 58.6 0 2.8.2 5.6.6 8.3.2 1.3 1.3 2.2 2.5 2.2H152c1.4 0 2.6-1 3-2.3l-.4-9.3z"
      />
      <path
        fill="#F38020"
        d="M154.4 57.5l1.1-3.8c1.3-4.5.8-8.7-1.4-11.8-2-2.8-5.5-4.5-9.6-4.6L65.8 36.3c-.5 0-.9-.3-1.2-.7-.2-.4-.3-.9-.1-1.4.3-.8 1.1-1.4 2-1.4l79.9-1c9.5-.4 19.7-8.1 23.3-17.4l4.6-11.8c.2-.5.3-1 .1-1.5-5.2-23.5-26-41-50.9-41C92.3-39.5 65.7-13 65.7 19.6c0 2.8.2 5.6.6 8.3.2 1.3 1.3 2.2 2.5 2.2h83l3-2.3-.4 29.7z"
        transform="translate(0 19)"
      />
    </svg>
  )
}

// Versión simplificada de Cloudflare que sí es la nube oficial
export function CloudflareLogoSimple({ size = 24, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Cloudflare"
    >
      <path
        fill="#F38020"
        d="M48.8 33.2c-.4-.4-1-.6-1.6-.6h-1.5c-.6 0-1.1-.5-1.1-1.1 0-.1 0-.3.1-.4l3.6-6.5c.3-.6.5-1.3.5-2.1 0-1.9-1.1-3.5-2.8-4.1l-3.5-1.3c-.6-.2-1.1-.7-1.3-1.4l-.8-3c-.5-1.8-2.1-3.1-4-3.1h-1.3c-.5 0-1-.2-1.3-.6L31.6 6c-.7-.8-1.6-1.2-2.7-1.2-1 0-2 .4-2.7 1.2l-2.2 2.4c-.4.4-.9.6-1.4.6h-1.3c-1.9 0-3.5 1.3-4 3.1l-.8 3c-.2.6-.7 1.2-1.3 1.4l-3.5 1.3c-1.6.6-2.8 2.2-2.8 4.1 0 .8.2 1.5.5 2.1l3.6 6.5c.1.1.1.3.1.4 0 .6-.5 1.1-1.1 1.1h-1.5c-.6 0-1.2.2-1.6.6-.9.8-.9 2.2 0 3l9 8.4c.5.5 1.1.8 1.8.8h22.4c.7 0 1.3-.3 1.8-.8l9-8.4c.9-.8.9-2.2 0-3z"
      />
    </svg>
  )
}

// Icono de refresh para el botón "Chequear ahora"
export function RefreshIcon({ size = 16, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M21 12a9 9 0 11-3.5-7.13M21 4v6h-6"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
